import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  setDoc,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const PLAYER_COLLECTION = "playerRankingSnapshots";
const ORG_COLLECTION = "organizationRankingSnapshots";

function playerSnapRef(id) {
  return doc(db, PLAYER_COLLECTION, id);
}

function orgSnapRef(id) {
  return doc(db, ORG_COLLECTION, id);
}

export async function upsertPlayerRankingSnapshot(snapshotId, data) {
  await setDoc(
    playerSnapRef(snapshotId),
    {
      ...data,
      snapshotId,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

export async function fetchPlayerRankingSnapshot(snapshotId) {
  if (!snapshotId) return null;
  const snap = await getDoc(playerSnapRef(snapshotId));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

/**
 * @param {{ seasonKey?: string, max?: number }} [options]
 */
export async function listPlayerRankingSnapshots(options = {}) {
  const max = Math.min(options.max || 50, 80);
  try {
    const constraints = [];
    if (options.seasonKey) {
      constraints.push(where("seasonKey", "==", options.seasonKey));
    }
    constraints.push(orderBy("points", "desc"));
    constraints.push(limit(max));
    const snap = await getDocs(query(collection(db, PLAYER_COLLECTION), ...constraints));
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch {
    const snap = await getDocs(query(collection(db, PLAYER_COLLECTION), limit(max)));
    let rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    if (options.seasonKey) {
      rows = rows.filter((r) => r.seasonKey === options.seasonKey);
    }
    return rows.sort((a, b) => (b.points || 0) - (a.points || 0));
  }
}

export async function upsertOrganizationRankingSnapshot(snapshotId, data) {
  await setDoc(
    orgSnapRef(snapshotId),
    {
      ...data,
      snapshotId,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

export async function listOrganizationRankingSnapshots(options = {}) {
  const max = Math.min(options.max || 40, 60);
  try {
    const constraints = [];
    if (options.seasonKey) {
      constraints.push(where("seasonKey", "==", options.seasonKey));
    }
    constraints.push(orderBy("totalPoints", "desc"));
    constraints.push(limit(max));
    const snap = await getDocs(query(collection(db, ORG_COLLECTION), ...constraints));
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch {
    const snap = await getDocs(query(collection(db, ORG_COLLECTION), limit(max)));
    let rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    if (options.seasonKey) {
      rows = rows.filter((r) => r.seasonKey === options.seasonKey);
    }
    return rows.sort((a, b) => (b.totalPoints || 0) - (a.totalPoints || 0));
  }
}

export { PLAYER_COLLECTION, ORG_COLLECTION };
